export enum TypoVariant {
  title = 'title',
  text = 'text',
}
export type TypoVariantType = `${TypoVariant}`
